import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { StyleSheetManager } from 'styled-components';
import { store, persistor } from './store';
import reportWebVitals from './reportWebVitals';
import { initializeCSP } from './utils/cspUtils';
import './index.css';
import './external.css';
import 'assets/fonts/FilsonProRegular.otf';
import 'mediaQuery/mobile.css';
import 'mediaQuery/tablet.css';
import 'mediaQuery/windows.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import App from 'routes';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize CSP utilities
initializeCSP();

persistor.subscribe(() => {
  const { bootstrapped } = persistor.getState();
  if (bootstrapped) {
    // Rehydration is complete
    // Load your app or perform any necessary actions
    // Get server-generated nonce for CSP compliance (Thymeleaf provides window.cspNonce)
    const nonce = window.cspNonce || 'fallback-nonce-for-development';

    // Log nonce status for debugging
    console.log('Styled-Components Nonce:', {
      nonce: nonce.substring(0, 10) + '...',
      isServerGenerated: !!window.cspNonce,
      isFallback: !window.cspNonce
    });

    root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <StyleSheetManager nonce={nonce}>
            <App />
          </StyleSheetManager>
        </PersistGate>
      </Provider>
    );
  }
});

reportWebVitals();
